module.exports = __webpack_public_path__ + "static/media/slick.b7c9e1e4.woff";


//////////////////
// WEBPACK FOOTER
// ./~/slick-carousel/slick/fonts/slick.woff
// module id = 185
// module chunks = 0